// SPDX-FileCopyrightText: Copyright Orangebot, Inc. and Medplum contributors
// SPDX-License-Identifier: Apache-2.0

import { Stack } from '@mantine/core';
import { IconChartBar, IconChecklist, IconCreditCard, IconFileInvoice, IconTag } from '@tabler/icons-react';
import type { JSX } from 'react';
import { Outlet, useLocation, useNavigate } from 'react-router';
import type { PageTabsItem } from '../../components/layout/PageTabs';
import { PageTabs } from '../../components/layout/PageTabs';
import classes from './BillingShell.module.css';

const BILLING_TABS: (PageTabsItem & { path: string })[] = [
  {
    id: 'dashboard',
    label: 'Dashboard',
    icon: <IconChartBar size={14} />,
    disabled: true,
    path: '/billing/dashboard',
  },
  { id: 'eligibility', label: 'Eligibility', icon: <IconChecklist size={14} />, path: '/billing/eligibility' },
  {
    id: 'patient-payments',
    label: 'Patient Payments',
    icon: <IconCreditCard size={14} />,
    path: '/billing/patient-payments',
  },
  { id: 'claims', label: 'Claims', icon: <IconFileInvoice size={14} />, path: '/billing/claims' },
  {
    id: 'chargemaster',
    label: 'Chargemaster',
    icon: <IconTag size={14} />,
    path: '/billing/chargemaster',
  },
];

export function BillingShell(): JSX.Element {
  const location = useLocation();
  const navigate = useNavigate();
  const currentTab = BILLING_TABS.find((t) => location.pathname === t.path)?.id ?? 'claims';

  return (
    <Stack gap="md" p="md" className={classes.root}>
      <div className={classes.pageHead}>
        <h1>Billing</h1>
        <PageTabs
          tabs={BILLING_TABS}
          value={currentTab}
          onChange={(id) => {
            const tab = BILLING_TABS.find((t) => t.id === id);
            if (tab) {
              navigate(tab.path)?.catch(console.error);
            }
          }}
        />
      </div>
      <Outlet />
    </Stack>
  );
}
